(function () {
    'use strict';
    $(document).ready(function () {

        const productsPhotosSwiper = new Swiper('.swiper.products-photos-swiper', {
            effect: 'fade',
            fadeEffect: {
                crossFade: true
            },
        });

        const productsSwiper = new Swiper('.swiper.products-swiper', {
            spaceBetween: 30,
            navigation: {
                prevEl: '.homepage-esg .products .swiper-button-prev',
                nextEl: '.homepage-esg .products .swiper-button-next',
            },
        });

        productsPhotosSwiper.controller.control = productsSwiper;
        productsSwiper.controller.control = productsPhotosSwiper;

        $('.swiper.tabs-content-swiper').each(function (index) {
            var swiperId = $(this).attr('id');
            var tabsContentSwiper = new Swiper($(this)[0], {
                pagination: {
                    el: '#' + swiperId + ' .swiper-pagination',
                    clickable: true,
                },
                navigation: {
                    prevEl: '#' + swiperId + ' .swiper-button-prev',
                    nextEl: '#' + swiperId + ' .swiper-button-next',
                },
                observer: true,
                observeParents: true,
            });
        });

    });
}(jQuery));
